export default __webpack_public_path__ + "static/media/chevron-up.7d30242c.svg";